import React from "react";
import { useNavigate } from "react-router";
import "./App.css";


const ResetButton = () => {
  const navigate = useNavigate();
  

  const handleReset = () => {
    localStorage.clear();
    navigate("/Questions");
    
  
  };

  return (
    <button className="resetButton" onClick={handleReset}>
      Reset
    </button>
  );
};

export default ResetButton;
